import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { ToastContainer } from 'react-toastify';
import { CurrencyProvider } from './Website/context/CurrencyContext'; 

//so browser does not try to restore the scroll position automatically
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Define the theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Customize primary color
    },
    secondary: {
      main: '#dc004e', // Customize secondary color
    },
  },
  typography: {
    fontFamily: 'Amiri, sans-serif !important',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <CurrencyProvider> {/* Add this wrapper */}
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <ToastContainer
            position="top-right"
            autoClose={2000}
            theme='dark'
            style={{ width: "350px" }}
          >
          </ToastContainer>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </CurrencyProvider> 
  </Provider>
);